import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "caass-portal-app-batch-import-table",
	templateUrl: "./portal-app-batch-import-table.component.html",
	styleUrls: ["./portal-app-batch-import-table.component.css"],
})
export class PortalAppBatchImportTableComponent implements OnInit {
	constructor() {}
	ngOnInit(): void {}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	SelectedPersons: any = [];
	lstPerson: any = [];
	@Input() TableLoading: boolean = false;

	pagerows: any = 10;
	pagefirst: any = 0;

	lstActiveDesc: any = [];
	lstAppDesc: any = [];
	lstValidEntryDesc: any = [];
	lstProgressDesc: any = [];

	cols: any = [
		{ field: "ID", header: "ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "SchoolFullName", header: "School" },
		{ field: "ActiveDesc", header: "Active" },
		{ field: "Email", header: "Email" },
		{ field: "AppDesc", header: "App" },
		{ field: "ValidEntryDesc", header: "Valid Entry" },
		{ field: "ProgressDesc", header: "Progress" },
	];

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	UpdateData(lstData: any) {
		this.lstPerson = lstData;
		this.UpdateFilterLists();
	}

	RemoveSelected() {
		this.lstPerson = this.lstPerson.filter((person) => this.SelectedPersons.indexOf(person) == -1);
		this.SelectedPersons = [];
		this.UpdateFilterLists();
	}

	RemoveInvalid() {
		this.lstPerson = this.lstPerson.filter((person) => person.ValidEntry == true);
		this.SelectedPersons = [];
		this.UpdateFilterLists();
	}

	UpdateFilterLists() {
		this.lstActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ActiveDesc))).sort();
		this.lstAppDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.AppDesc))).sort();
		this.lstValidEntryDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ValidEntryDesc))).sort();
		this.lstProgressDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ProgressDesc))).sort();
	}

	////////////////////////////////////////////
}
